import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import { BoardInstructionTypes } from 'types/Board';
import { BoardInstruction, BoardOrder } from 'types';

import voteTypes from 'constants/voteTypes';
import voteValues from 'constants/voteValues';

type DelegateVoteInstructionsProps = {
  hasInstructions: boolean;
  instructions: BoardInstruction[];
  instructionType: BoardInstructionTypes;
  onChangeInstructionType: (value: string) => void; // eslint-disable-line
  onSaveInstruction: (value: string, index: number) => void; // eslint-disable-line
  orders: BoardOrder[];
};

export const DelegateVoteInstructions: FC<DelegateVoteInstructionsProps> = ({
  hasInstructions,
  instructions,
  instructionType,
  onChangeInstructionType,
  onSaveInstruction,
  orders,
}) => {
  const { t } = useTranslate();

  if (!hasInstructions) {
    return null;
  }

  return (
    <>
      <div className="form-group mt-3">
        <label className="form-label" htmlFor="full-name">
          {t('SelectHowTheDelegateVote')}
        </label>
        <div className="row">
          <div className="col-md-3">
            <div className="custom-control custom-control-sm custom-radio custom-control-pro">
              <input
                type="radio"
                className="custom-control-input"
                name="btnRadio"
                id="btnRadio1"
                value={BoardInstructionTypes.ALL_YES}
                checked={instructionType === BoardInstructionTypes.ALL_YES}
                onChange={(event) =>
                  onChangeInstructionType(event.target.value)
                }
              />
              <label className="custom-control-label" htmlFor="btnRadio1">
                {t('AllYes')}
              </label>
            </div>
          </div>
          <div className="col-md-3">
            <div className="custom-control custom-control-sm custom-radio custom-control-pro">
              <input
                type="radio"
                className="custom-control-input"
                name="btnRadio"
                id="btnRadio2"
                value={BoardInstructionTypes.ALL_NO}
                checked={instructionType === BoardInstructionTypes.ALL_NO}
                onChange={(event) =>
                  onChangeInstructionType(event.target.value)
                }
              />
              <label className="custom-control-label" htmlFor="btnRadio2">
                {t('AllNo')}
              </label>
            </div>
          </div>
          <div className="col-md-3">
            <div className="custom-control custom-control-sm custom-radio custom-control-pro">
              <input
                type="radio"
                className="custom-control-input"
                name="btnRadio"
                id="btnRadio3"
                value={BoardInstructionTypes.ALL_ABS}
                checked={instructionType === BoardInstructionTypes.ALL_ABS}
                onChange={(event) =>
                  onChangeInstructionType(event.target.value)
                }
              />
              <label className="custom-control-label" htmlFor="btnRadio3">
                {t('AllAbs')}
              </label>
            </div>
          </div>
          <div className="col-md-3">
            <div className="custom-control custom-control-sm custom-radio custom-control-pro">
              <input
                type="radio"
                className="custom-control-input"
                name="btnRadio"
                id="btnRadio4"
                value={BoardInstructionTypes.POINT_BY_POINT}
                checked={
                  instructionType === BoardInstructionTypes.POINT_BY_POINT
                }
                onChange={(event) =>
                  onChangeInstructionType(event.target.value)
                }
              />
              <label className="custom-control-label" htmlFor="btnRadio4">
                {t('PointByPoint')}
              </label>
            </div>
          </div>
        </div>
      </div>

      {instructionType === BoardInstructionTypes.POINT_BY_POINT &&
        orders.length > 0 && (
          <>
            <label className="form-label mt-2" htmlFor="full-name">
              {t('SetOneVoteForEachPoint')}
            </label>

            {orders.map((order, index) => (
              <div
                key={order['_id']}
                className="card-inner card-bordered mt-2 round-lg"
              >
                <span className="p-2">{`${index + 1}. ${order.subject}`}</span>

                {order.voteType === voteTypes.YES_NO_ABS.value && (
                  <div className="form-group p-2 mt-1">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                          <input
                            type="radio"
                            className="custom-control-input"
                            name={`btnRadio-${order['_id']}`}
                            id={`btnRadio1-${order['_id']}`}
                            value={voteValues.YES.value}
                            checked={
                              instructions[index].vote === voteValues.YES.value
                            }
                            onChange={(event) =>
                              onSaveInstruction(event.target.value, index)
                            }
                          />
                          <label
                            className="custom-control-label"
                            htmlFor={`btnRadio1-${order['_id']}`}
                          >
                            {t('Yes')}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                          <input
                            type="radio"
                            className="custom-control-input"
                            name={`btnRadio-${order['_id']}`}
                            id={`btnRadio2-${order['_id']}`}
                            value={voteValues.NO.value}
                            checked={
                              instructions[index].vote === voteValues.NO.value
                            }
                            onChange={(event) =>
                              onSaveInstruction(event.target.value, index)
                            }
                          />
                          <label
                            className="custom-control-label"
                            htmlFor={`btnRadio2-${order['_id']}`}
                          >
                            {t('Nope')}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                          <input
                            type="radio"
                            className="custom-control-input"
                            name={`btnRadio-${order['_id']}`}
                            id={`btnRadio3-${order['_id']}`}
                            value={voteValues.ABS.value}
                            checked={
                              instructions[index].vote === voteValues.ABS.value
                            }
                            onChange={(event) =>
                              onSaveInstruction(event.target.value, index)
                            }
                          />
                          <label
                            className="custom-control-label"
                            htmlFor={`btnRadio3-${order['_id']}`}
                          >
                            {t('Abstention')}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </>
        )}
    </>
  );
};
